module.exports = __webpack_public_path__ + "img/icon7.66a6ade8.png";